export default {
  title: 'Create Onboarding Link',
  steps: {
    select_gateway: 'Select Gateway',
    copy_link: 'Copy Link',
  },
  select_gateway: {
    description: 'Choose the payment gateway for which you want to generate a long-living onboarding link.',
  },
  link: {
    proxy_url_label: 'Onboarding URL',
    expires_label: 'Expires',
    copy_button: 'Copy URL',
    copied: 'Copied!',
    description:
      'Share this URL with the merchant. It redirects to the gateway onboarding page and stays valid until the expiry date.',
  },
  buttons: {
    next: 'Next',
    back: 'Back',
    done: 'Done',
  },
  toasts: {
    create_success: 'Onboarding link created successfully.',
    create_failed: 'Failed to create onboarding link.',
  },
};
